import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {
    DetailFormPageShell,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import Th_title from "../../../components/Th_title";
import {CodeIdType, CodeSpecNum, CodeType} from "../../../constant/CodeSpecNum";
import {saveRentalAssets} from "../../../api/lifecycle/rental/rentalAssetService";
import {onCreateIdClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import {validation} from "../../serviceRequest/serviceRequest/serviceUtils";

const RentalAssetCreate = () => {
    const [assets, setAssets] = useState([]);
    const [rentalAsset, setRentalAsset] = useState({});

    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleSaveRentalAsset = async () => {
        const validationData = {
            assets: assets,
            rentalAssetCode: rentalAsset.rentalAssetCode
        }
        if (!validation(validationData, t)) return;

        const assetIds = assets.map(asset => asset.id);
        const data = {codeId: rentalAsset.rentalAssetCode.id, assetIds};

        await saveRentalAssets(data, () => {
            window.alert(t('saved'));
            navigate("/lifecycle/rentalAsset/list");
        });
    }

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="대여자산 등록"
            meta="신규 대여자산 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/lifecycle/rentalAsset/list")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("저장하시겠습니까?")) {
                                handleSaveRentalAsset();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <DetailPanel title="대여자산 등록">
                        <DetailKvTable>
                            <tbody>
                            <tr>
                                <Th_title title={"대여자산코드"} colspan={3} className="fieldset-td" required auth>
                                    <Selector
                                        onChange={(value) => onCreateIdClickListener(
                                            setRentalAsset, CodeType.rentalAssetCode, CodeIdType.rentalAssetCodeId,
                                            rentalAsset.rentalAssetCode, value
                                        )}
                                        data={rentalAsset.rentalAssetCode}
                                        entity={"code"}
                                        parentKey={CodeSpecNum.RentalAssetCode}
                                        recursive auth
                                    />
                                </Th_title>
                            </tr>
                            <tr className="asset-detail-kv-row--auto">
                                <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top" required auth>
                                    <UserSelectionField
                                        layout="inline"
                                        data={assets}
                                        countUnit="개"
                                        chipEntity="asset"
                                        listModalTitle="자산목록"
                                        onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                                    >
                                        <SearchSelector
                                            auth
                                            multiSelect
                                            variant="compact"
                                            entity="rental"
                                            uniqueKey="assets"
                                            data={assets}
                                            onChange={(v) => {
                                                if (v?.__multiFlat) setAssets(v.__multiFlat);
                                            }}
                                        >
                                            <SimmsInputSearch type="TEXT"/>
                                            <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                            <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                            <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                            <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                            <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                                        </SearchSelector>
                                    </UserSelectionField>
                                </Th_title>
                            </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
};

export default RentalAssetCreate;
